module.exports = __webpack_public_path__ + "media/images/icon-arrowup-3d8a49c3b433cbdb18b277723c3d2f90.png";